<template>
  <div>
    <div class="wall">
      <div class="wall-head">退款/售后列表</div>
      <!-- <search-bar class="media-body"  @on-search="handleSearch"/> -->
    </div>
    <div class="mt-30 wall">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待审核" name="unaudited"></el-tab-pane>
        <el-tab-pane label="处理中" name="processing"></el-tab-pane>
      </el-tabs>
      <div class="p-30">
        <div v-if="!bodyLoading && tableData.length < 1" class="flex-center-center">
          <div class="color-lightGray">暂无数据</div>
        </div>
        <table class="order-table" border="0" cellspacing="0" cellpadding="0" v-loading="bodyLoading">
          <template v-for="(order, index) in tableData">
            <tr :key="index" class="head">
              <td>
                退款单号：{{ order.aftersale_id }}
              </td>
              <td>
                申请时间：{{ order.create_time| format_date}}
              </td>
              <td align="center">数量</td>
              <td align="center">金额</td>
              <td align="center">申请理由</td>
              <td align="center">客户</td>
              <td align="center">状态</td>
            </tr>
            <tr :key="'column'+index">
              <td colspan="2" class="pt-10 pb-30" style="width: 320px;">
                <div class="d-flex">
                  <img :src="order.order_goods.sku.picture + ''" alt="" style="width: 80px; height: 80px;">
                  <div class="p-10 d-flex flex-column flex-body" style="width: 220px;">
                    <div class="clamp">{{ order.order_goods.sku.title }}</div>
                    <div class="mt-auto color-sliver">{{ order.order_goods.sku.specs|obj_to_string }}</div>
                    <div class="mt-10 color-sliver">关联订单：<router-link
                      :to="{ path: '/order/item', query: { order_id: order.order_id } }"
                      class="color-primary"
                    >{{order.order_id}}</router-link></div>
                  </div>
                </div>
              </td>
              <td align="center">{{ order.order_goods.count }}</td>
              <td align="center">{{ order.order_goods.pay_amount }}</td>
              <td align="center">{{ order.apply_reason }}</td>
              <td align="center">{{ order.user&&(order.user.name||order.user.username||order.user.id) }}</td>
              <td align="center">
                <div :style="{color:statusObj[order.status].color}">{{ statusObj[order.status].text }}</div>
                <div v-if="order.status==='unaudited'">
                  <div class="mt-10"><el-button type="primary" @click="_refundApprove(order.aftersale_id)" size="mini">同意退款</el-button></div>
                  <div class="mt-10"><el-button type="text" @click="handleRefuseClick(order.aftersale_id)" size="small" class="color-primary">拒绝退款</el-button></div>
                </div>
              </td>
            </tr>
          </template>
        </table>
      </div>

      <div class="flex-center-center pb-20"> 
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalItems"
          @current-change="handlePageChage">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      v-if="dialogVisible"
      title="拒绝退款"
      :visible.sync="dialogVisible"
      width="750px">
      <rs-form ref="form" :model="formData" :rules="rules"  label-width="90px" class="mt-20">
        <el-form-item label="拒绝原因" prop="refuse_reason">
          <el-input v-model="formData.refuse_reason"></el-input>
        </el-form-item>
      </rs-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import SearchBar from './components/Searchbar.vue';
import {
  getRefundList,
  refundApprove,
  refundRefuse
} from '@/api/order.js';

export default {
  // components: {
  //   SearchBar
  // },
  data() {
    return {
      bodyLoading: false,
      activeName: 'all',
      currentPage: 1,
      pageSize: 15,
      totalItems: 0,
      tableData: [],
      checkAll: false,
      checkedOrders: [],
      deliverVisible: false,
      file: null,
      dialogLoading: false,
      statusObj:{
        unaudited:{text:'待商家处理',color:'#67C23A'},
        processing: {text:'处理中',color:'#67C23A'},
        cancel: {text:'已取消',color:'#999999'},
        refused: {text:'已拒绝',color:'#ED4645'},
        refunded: {text:'已退款',color:'#999999'},
        returned: {text:'已退货',color:'#999999'}
      },
      dialogVisible: false,
      formData:{refuse_reason: ''},
      aftersale_id: '',
      rules: {
        refuse_reason: [
          { required: true, message: '请填写拒绝原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    initParams(){
      this.currentPage = 1
      this.pageSize = 15
      this.totalItems = 0
    },
    async _getRefundList(){
      this.bodyLoading = true
      let params = {
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize,
        status: this.activeName==='all'?'':this.activeName,
      }
      let {count, results} = await getRefundList(params)
      this.totalItems = count
      this.tableData = results
      
      this.bodyLoading = false
    },
    async _refundApprove(id){
      await refundApprove(id)
      this.$message({
        message: "已提交退款请求,请等待银行操作",
        type: "success"
      });
      this._getRefundList()
    },
    async _refundRefuse(){
      await refundRefuse(this.aftersale_id,{refuse_reason:this.formData.refuse_reason})
      this.$message({
        message: "已拒绝退款",
        type: "success"
      });
      this._getRefundList()
    },
    handlePageChage(v){
      // 切换页码
      this.currentPage = v;
      this._getRefundList();
    },
    handleClick(tab){
      this.activeName = tab.name
      this.initParams()
      this._getRefundList()
    },
    handleRefuseClick(id){
      this.aftersale_id = id
      this.dialogVisible = true
    },
    handleConfirm(){
      this.$refs['form'].validate(async(valid) => {
        if (!valid) return false;
        await this._refundRefuse()
        this.dialogVisible = false
      });
    }
  },
  created(){
    this._getRefundList()
  }
}
</script>

<style scoped lang="scss">
.order-table {
  width: 100%;
  font-size: 12px;
  color: $black;
  .head {
    background-color: rgba(255,125,98,0.06);
    color: $lightGray;
    td {
      padding: 10px 5px;
      border: none;
    }
  }
}
</style>